function demo(config: Record<string, any> = {}): () => void {
    const onKeyDown = function (this: Document, evt: KeyboardEvent): void {
        if (typeof config.fnAction === 'function') {
            config.fnAction.call(this, evt);
        } else {
            console.log(evt);
        }
    };

    document.addEventListener('keydown', onKeyDown);

    return function cleanup(): void {
        document.removeEventListener('keydown', onKeyDown);
    };
}

// ----------------------------------------------------------------------------

export default demo;
